import { TotalDueLine } from "./Lines/TotalDueLine";
import { ViewOrderDetailsLine } from "./Lines/ViewOrderDetailsLine";

export const MobileFixedOnTopPreview = () => (
  <div className="bg-primary fixed z-10 flex w-full flex-row justify-between border-b px-5 py-4 md:hidden">
    <ViewOrderDetailsLine />
    <TotalDueLine.Value />
  </div>
);
